<template>
  <main class="narrow-view">
    <h1>
      {{ $t('bowler-registration.heading') }}
    </h1>

    <BowlerRegistrationRequestForm />
  </main>
</template>

<script lang="ts" setup>
import BowlerRegistrationRequestForm from '@/components/forms/BowlerRegistrationRequestForm.vue'
</script>
